import { constants } from '../../config';
import { getHeaders, post } from './services.common';

export const applyCouponService = async (data: any) => {
  const url = constants.API + `/store/YuStoreCoupons/check-eligibility`;
  const headers = { ...getHeaders() };
  const response = await post({
    url,
    headers,
    data: data,
  });
  return response;
};

export const placeOrderService = async (data: any) => {
  const url = constants.API + `/store/PurchaseOrder/create`;
  const headers = { ...getHeaders() };
  const response = await post({
    url,
    headers,
    data: data,
  });
  return response;
};